import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { HelpEffects } from '@appStore/help/effects/help.effects';
import { GuidesEffects } from '@appStore/help/effects/guides.effects';
import { UserGuidesEffects } from '@appStore/help/effects/user-guides.effects';

export const effects: any[] = [HelpEffects, GuidesEffects, UserGuidesEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class HelpEffectsModule {}
